import { jsx as _jsx } from "react/jsx-runtime";
import { FeatureFlag, useFeatureFlag } from '../../Contexts/FeatureFlagContext';
import { DefaultKYCPage } from './DefaultKYCPage';
import { KYCUserVerification } from './KYCUserVerification';
export var KYCPageManager = function () {
    var isCustomKYCEnabled = useFeatureFlag(FeatureFlag.CUSTOM_KYC);
    if (!isCustomKYCEnabled) {
        return _jsx(DefaultKYCPage, {});
    }
    return _jsx(KYCUserVerification, {});
};
